Namespace 'Monitoring.Reports.DailyInsights'

class Monitoring.Reports.DailyInsights.FacebookPostPreviewView extends Backbone.View
  className: 'post-preview'
  template: JST['backbone/templates/monitoring/reports/daily_insights/facebook_post_preview']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.html(@template(post: @options.post.updated_data, link: @options.post.full_content.data.content.url, date: @options.post.full_content.data.content.createdat))
